import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './SignupWizard.module.css';

const SignupProgressBar = props => {
  const { progress, className } = props;

  const classes = classNames(css.progressBar, className);

  return (
    <div className={classes}>
      <div
        className={css.progressFill}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

SignupProgressBar.defaultProps = {
  className: null,
  progress: 0,
};

SignupProgressBar.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number,
};

export default SignupProgressBar;
